// import React from 'react'
// import FadeInSectionDownToUp from '../../Components/FadeAnimations/FadeInSectionDownToUp'
// import { FaLocationDot } from "react-icons/fa6";

// export default function Branches() {

//     const branches = [

//         {
//             img: "https://albidayahgroups.com/Media/Branches/11.png",
//             name: "RESTORAN AL-BIDAYAH SELANGOR - Since 1996",
//             location: "https://share.google/dLo5FtCBI541SDEUx",
//             address: "24, Jalan 2/12, Dataran Templer, 68100 Batu Caves, Selangor",
//             phoneNo: "+6 0367327286",
//         },
//         {
//             img: "https://albidayahgroups.com/Media/Branches/02.png",
//             name: "RESTORAN AL-BIDAYAH KLANG - Since 2004",
//             location: "https://share.google/vhDJ7feWwdCuwbPt5",
//             address: "34, Jalan Sri Sarawak 19, Taman Sri Andalas, 41200 Klang, Selangor",
//             phoneNo: "+6 0187867701",
//         },
//         {
//             img: "https://albidayahgroups.com/Media/Branches/03.png",
//             name: "RESTORAN AL-BIDAYAH RAWANG - Since 2008",
//             location: "https://share.google/TX0Ep0d723ogQLVJB",
//             address: "18, Jalan Desa 1/1, Bandar Country Homes, 48000 Rawang, Selangor",
//             phoneNo: "+6 0168060881",
//         },
//         {
//             img: "https://albidayahgroups.com/Media/Branches/04.png",
//             name: "RESTORAN AL-BIDAYAH SETIAWANGSA - Since 2012",
//             location: "https://share.google/dctHcNrAjwGO55yTS",
//             address: "No 23, 55A, Jalan Setiawangsa 8, Taman Setiawangsa, 54200 Kuala Lumpur, Wilayah Persekutuan Kuala Lumpur",
//             phoneNo: "+6 0342652023",
//         },
//         {
//             img: "https://albidayahgroups.com/Media/Branches/05.png",
//             name: "RESTORAN AL-BIDAYAH TTDI - Since 2015",
//             location: "https://share.google/WyLPBsMJOEvoXISQK",
//             address: "1, Lorong Rahim Kajai 13, Taman Tun Dr Ismail, 60000 Kuala Lumpur, Wilayah Persekutuan Kuala Lumpur",
//             phoneNo: "+6 0377319167",
//         },
//         {
//             img: "https://albidayahgroups.com/Media/Branches/06.png",
//             name: "RESTORAN AL-BIDAYAH MASJID INDIA - Since 2015",
//             location: "https://share.google/cmBCvcI438IrDCqlh",
//             address: "83, Jalan Masjid India, City Centre, 50100 Kuala Lumpur, Wilayah Persekutuan Kuala Lumpur",
//             phoneNo: "+6 0104324233",
//         },
//         {
//             img: "https://albidayahgroups.com/Media/Branches/07.png",
//             name: "RESTORAN AL-BIDAYAH KUALA SELANGOR - Since 2015",
//             location: "https://share.google/rnjkY2KHmOmC9aa9b",
//             address: "No 50 Jalan Melawati 3/17, Bandar Melawati, 45000 Kuala Selangor, Selangor Darul Eshan",
//             phoneNo: "+6 0332813338",
//         },
//         {
//             img: "https://albidayahgroups.com/Media/Branches/08.png",
//             name: "RESTORAN AL-BIDAYAH CYBERJAYA - Since 2016",
//             location: "https://share.google/VtWXp0BTsbXxCWqHd",
//             address: "Gem In Mall, Persiaran Sepang, Cyber 11, 63000 Cyberjaya, Selangor",
//             phoneNo: "",
//         },
//         {
//             img: "https://albidayahgroups.com/Media/Branches/09.png",
//             name: "RESTORAN AL-BIDAYAH SINGAPORE - Since 2017",
//             location: "https://share.google/oeSpbEQq1HXFQWgX9",
//             address: "364 Geylang Rd, Singapore 389369",
//             phoneNo: "+65 67466786",
//         },
//         {
//             img: "",
//             name: "RESTORAN AL-BIDAYAH PLAZA KLTS - Since 2018",
//             location: "https://share.google/mkLWUhLufuh3Lqrg6",
//             address: "No 1 G Block A, Plaza KLTS, Jln Gombak, Kampung Kuantan, 53300 KLTS, Federal Territory of Kuala Lumpur",
//             phoneNo: "+6 0340314267",
//         },
//         {
//             img: "https://albidayahgroups.com/Media/Branches/13.png",
//             name: "RESTORAN AL-BIDAYAH SENTUL POINT - Since 2021",
//             location: "https://share.google/wNtuRjBC3uhcPy5A3",
//             address: "AG-21, 8, Jln Sentul Pasar, Puncak sentul, 51000 Kuala Lumpur, Wilayah Persekutuan Kuala Lumpur",
//             phoneNo: "+6 0340238121",
//         },
//         {
//             img: "https://albidayahgroups.com/Media/Branches/12.png",
//             name: "RESTORAN AL-BIDAYAH PULAU PINANG - Since 2022",
//             location: "https://share.google/HmA41NpcEpBMvOzQ0",
//             address: "34g, Lbh Sungai Pinang 1, 11600 George Town, Pulau Pinang",
//             phoneNo: "+6 042805239",
//         },
//         {
//             img: "https://albidayahgroups.com/Media/Branches/19.png",
//             name: "MADRAS BAKERY MASJID INDIA - Since 2023",
//             location: "https://share.google/iOv8iaPwCIPc90a34",
//             address: "92, Ground Floor, Jalan Medan Bunus, Jalan Masjid India, 50100 Kuala Lumpur, Wilayah Persekutuan Kuala Lumpur",
//             phoneNo: "+6 0182808449",
//         },
//         {
//             img: "https://albidayahgroups.com/Media/Branches/20.png",
//             name: "RESTORAN JUNIOR KUPANNA LEBUH AMPANG - Since 2023",
//             location: "https://share.google/p6JB811lO5Z4b6AzR",
//             address: "10 & 12 Jalan Gereja, Lebuh Ampang, 50100 Kuala Lumpur, Federal Territory of Kuala Lumpur",
//             phoneNo: "+6 0189571098",
//         },
//         {
//             img: "https://albidayahgroups.com/Media/Branches/16.png",
//             name: "RESTORAN AB EXPRESS PLAZA KLTS - Since 2023",
//             location: "https://share.google/EKPLknFXDEREmq5p2",
//             address: "45-1, Plaza KLTS, Kampung Kuantan, 53000 Kuala Lumpur, Federal Territory of Kuala Lumpur",
//             phoneNo: "+6 01127668379",
//         },
//         {
//             img: "https://albidayahgroups.com/Media/Branches/17.png",
//             name: "RESTORAN AL-BIDAYAH KUANTAN - Since 2024",
//             location: "https://share.google/duN9rVxZA4VkQivLr",
//             address: "B56 Lorong Kg Padang Jaya, 27, Jalan Kuantan Sungai Lembing, Perkampungan Padang Jaya, 25200 Kuantan, Pahang",
//             phoneNo: "+6 095478510",
//         },
//         {
//             img: "",
//             name: "RESTORAN AL-BIDAYAH DESHA MELWATI - Since 2024",
//             location: "https://share.google/dyp563aPWlir4WbA1",
//             address: "23, Jalan 2/4C, Desa Melawati, 53100 Kuala Lumpur, Wilayah Persekutuan Kuala Lumpur",
//             phoneNo: "+6 0341621322",
//         },
//         {
//             img: "",
//             name: "RESTORAN COURTALLAM BORDER POROTTA - Since 2024",
//             location: "https://share.google/Q0EPAZki4OxxECZcy",
//             address: "83 Jalan Medan Bunus, Jalan Masjid India, 50100 Kuala Lumpur",
//             phoneNo: "+6 018916 1096",
//         },
//         {
//             img: "",
//             name: "MADRAS BAKERY BRICKFIELDS - Since 2024",
//             location: "https://share.google/tgHOYZaYKZvJhutDx",
//             address: "R15 / G-12, Sentral Suites Retail, Jalan Tun Sambanthan, Brickfields, 50470 Kuala Lumpur, Wilayah Persekutuan Kuala Lumpur",
//             phoneNo: "+6 0128682786",
//         },
//         {
//             img: "https://albidayahgroups.com/Media/Branches/15.png",
//             name: "RESTORAN JUNIOR KUPANNA BRICKFIELDS - Since 2024",
//             location: "https://share.google/fR8U5x3EfEdXzFcbs",
//             address: "182, Jalan Tun Sambanthan, Brickfields, 50470 Kuala Lumpur, Wilayah Persekutuan Kuala Lumpur",
//             phoneNo: "+6 0185733239",
//         },
//         {
//             img: "https://albidayahgroups.com/Media/Branches/14.png",
//             name: "MADRAS BAKERY LITTLE INDIA - Since 2024",
//             location: "https://share.google/MpXSGpe1bKZVo0xdG",
//             address: "261G, Ground Floor, Jalan Tun Sambanthan, Brickfields, 50470 Kuala Lumpur, Wilayah Persekutuan Kuala Lumpur",
//             phoneNo: "+6 0174716619",
//         },

//     ]

//     return (
//         <div>
//             <div className="relative w-full h-screen">
//                 {/* Background Image */}
//                 <div
//                     className="absolute inset-0 bg-cover bg-center"
//                     style={{ backgroundImage: `url('https://albidayahgroups.com/Media/Branches/Branch.jpg')` }}
//                 ></div>

//                 {/* Milled Dark Overlay */}
//                 <div className="absolute inset-0 bg-black bg-opacity-50 mix-blend-multiply"></div>

//                 {/* Text Overlay - Left Side */}
//                 <div className="relative z-10 flex items-center h-full px-6 md:px-16">
//                     <div className="text-white">
//                         <FadeInSectionDownToUp>
//                             <h1 className="text-6xl max-sm:text-4xl font-bold mb-4 leading-tight">
//                                 A Network of <span className='text-yellow-500'>Trust,</span><br />
//                                 Serving Communities.
//                             </h1>
//                             <p className="text-lg md:text-xl max-w-xl">
//                                 Welcome to AL-BIDAYAH Branches - where quality meets you, wherever you are.
//                             </p>
//                         </FadeInSectionDownToUp>
//                     </div>
//                 </div>
//             </div>
//             <div className='max-sm:pb-20'>
//                 <div className='flex justify-center items-center px-20 max-sm:px-5 py-20 max-sm:py-10'>
//                     <div className='grid grid-cols-3 max-sm:grid-cols-1 gap-10'>
//                         {branches.map((branch, index) => (
//                             <a key={index} href={branch.location} target="_blank" rel="noopener noreferrer">
//                                 <div className="space-y-3 w-full">
//                                     <FadeInSectionDownToUp>
//                                         {/* 🖼 Image Wrapper */}
//                                         <div className="relative w-full rounded-3xl">
//                                             <img
//                                                 src={branch.img}
//                                                 alt={branch.name}
//                                                 className="w-full object-cover rounded-3xl"
//                                             />
//                                             <div className="absolute top-3 right-3">
//                                                 <div className="relative group bg-white rounded-full p-2 shadow-md hover:scale-105 transition-all ease-in-out duration-500">
//                                                     <a href={branch.location} target="_blank" rel="noopener noreferrer">
//                                                         <FaLocationDot size={20} className="text-[#023E4E]" />
//                                                     </a>

//                                                     {/* Tooltip */}
//                                                     <div className="absolute top-full right-1/2 translate-x-1/2 mt-2 w-max px-3 py-1 text-sm text-white bg-black rounded opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10 whitespace-nowrap">
//                                                         Click for location
//                                                     </div>
//                                                 </div>
//                                             </div>


//                                             {/* 🏷 Bottom Left Label */}
//                                             <div className="absolute bottom-3 left-3 bg-white bg-opacity-90 text-[#023E4E] text-sm font-semibold px-3 py-1 rounded-full shadow">
//                                                 {branch.name}
//                                             </div>
//                                         </div>
//                                     </FadeInSectionDownToUp>

//                                     {/* 📦 Title Below Image */}
//                                     <p className="text-[#023E4E] text-xl">{branch.address}</p>
//                                 </div>
//                             </a>
//                         ))}
//                     </div>
//                 </div>
//             </div>
//         </div>
//     )
// }






// import React from "react";
// import FadeInSectionDownToUp from "../../Components/FadeAnimations/FadeInSectionDownToUp";
// import { FaLocationDot } from "react-icons/fa6";

// export default function Branches() {
//   const branches = [
//     {
//             img: "https://albidayahgroups.com/Media/Branches/11.png",
//             name: "RESTORAN AL-BIDAYAH SELANGOR - Since 1996",
//             location: "https://share.google/dLo5FtCBI541SDEUx",
//             address: "24, Jalan 2/12, Dataran Templer, 68100 Batu Caves, Selangor",
//             phoneNo: "+6 0367327286",
//         },
//         {
//             img: "https://albidayahgroups.com/Media/Branches/02.png",
//             name: "RESTORAN AL-BIDAYAH KLANG - Since 2004",
//             location: "https://share.google/vhDJ7feWwdCuwbPt5",
//             address: "34, Jalan Sri Sarawak 19, Taman Sri Andalas, 41200 Klang, Selangor",
//             phoneNo: "+6 0187867701",
//         },
//         {
//             img: "https://albidayahgroups.com/Media/Branches/03.png",
//             name: "RESTORAN AL-BIDAYAH RAWANG - Since 2008",
//             location: "https://share.google/TX0Ep0d723ogQLVJB",
//             address: "18, Jalan Desa 1/1, Bandar Country Homes, 48000 Rawang, Selangor",
//             phoneNo: "+6 0168060881",
//         },
//         {
//             img: "https://albidayahgroups.com/Media/Branches/04.png",
//             name: "RESTORAN AL-BIDAYAH SETIAWANGSA - Since 2012",
//             location: "https://share.google/dctHcNrAjwGO55yTS",
//             address: "No 23, 55A, Jalan Setiawangsa 8, Taman Setiawangsa, 54200 Kuala Lumpur, Wilayah Persekutuan Kuala Lumpur",
//             phoneNo: "+6 0342652023",
//         },
//         {
//             img: "https://albidayahgroups.com/Media/Branches/05.png",
//             name: "RESTORAN AL-BIDAYAH TTDI - Since 2015",
//             location: "https://share.google/WyLPBsMJOEvoXISQK",
//             address: "1, Lorong Rahim Kajai 13, Taman Tun Dr Ismail, 60000 Kuala Lumpur, Wilayah Persekutuan Kuala Lumpur",
//             phoneNo: "+6 0377319167",
//         },
//         {
//             img: "https://albidayahgroups.com/Media/Branches/06.png",
//             name: "RESTORAN AL-BIDAYAH MASJID INDIA - Since 2015",
//             location: "https://share.google/cmBCvcI438IrDCqlh",
//             address: "83, Jalan Masjid India, City Centre, 50100 Kuala Lumpur, Wilayah Persekutuan Kuala Lumpur",
//             phoneNo: "+6 0104324233",
//         },
//         {
//             img: "https://albidayahgroups.com/Media/Branches/07.png",
//             name: "RESTORAN AL-BIDAYAH KUALA SELANGOR - Since 2015",
//             location: "https://share.google/rnjkY2KHmOmC9aa9b",
//             address: "No 50 Jalan Melawati 3/17, Bandar Melawati, 45000 Kuala Selangor, Selangor Darul Eshan",
//             phoneNo: "+6 0332813338",
//         },
//         {
//             img: "https://albidayahgroups.com/Media/Branches/08.png",
//             name: "RESTORAN AL-BIDAYAH CYBERJAYA - Since 2016",
//             location: "https://share.google/VtWXp0BTsbXxCWqHd",
//             address: "Gem In Mall, Persiaran Sepang, Cyber 11, 63000 Cyberjaya, Selangor",
//             phoneNo: "",
//         },
//         {
//             img: "https://albidayahgroups.com/Media/Branches/09.png",
//             name: "RESTORAN AL-BIDAYAH SINGAPORE - Since 2017",
//             location: "https://share.google/oeSpbEQq1HXFQWgX9",
//             address: "364 Geylang Rd, Singapore 389369",
//             phoneNo: "+65 67466786",
//         },
//         {
//             img: "",
//             name: "RESTORAN AL-BIDAYAH PLAZA KLTS - Since 2018",
//             location: "https://share.google/mkLWUhLufuh3Lqrg6",
//             address: "No 1 G Block A, Plaza KLTS, Jln Gombak, Kampung Kuantan, 53300 KLTS, Federal Territory of Kuala Lumpur",
//             phoneNo: "+6 0340314267",
//         },
//         {
//             img: "https://albidayahgroups.com/Media/Branches/13.png",
//             name: "RESTORAN AL-BIDAYAH SENTUL POINT - Since 2021",
//             location: "https://share.google/wNtuRjBC3uhcPy5A3",
//             address: "AG-21, 8, Jln Sentul Pasar, Puncak sentul, 51000 Kuala Lumpur, Wilayah Persekutuan Kuala Lumpur",
//             phoneNo: "+6 0340238121",
//         },
//         {
//             img: "https://albidayahgroups.com/Media/Branches/12.png",
//             name: "RESTORAN AL-BIDAYAH PULAU PINANG - Since 2022",
//             location: "https://share.google/HmA41NpcEpBMvOzQ0",
//             address: "34g, Lbh Sungai Pinang 1, 11600 George Town, Pulau Pinang",
//             phoneNo: "+6 042805239",
//         },
//         {
//             img: "https://albidayahgroups.com/Media/Branches/19.png",
//             name: "MADRAS BAKERY MASJID INDIA - Since 2023",
//             location: "https://share.google/iOv8iaPwCIPc90a34",
//             address: "92, Ground Floor, Jalan Medan Bunus, Jalan Masjid India, 50100 Kuala Lumpur, Wilayah Persekutuan Kuala Lumpur",
//             phoneNo: "+6 0182808449",
//         },
//         {
//             img: "https://albidayahgroups.com/Media/Branches/20.png",
//             name: "RESTORAN JUNIOR KUPANNA LEBUH AMPANG - Since 2023",
//             location: "https://share.google/p6JB811lO5Z4b6AzR",
//             address: "10 & 12 Jalan Gereja, Lebuh Ampang, 50100 Kuala Lumpur, Federal Territory of Kuala Lumpur",
//             phoneNo: "+6 0189571098",
//         },
//         {
//             img: "https://albidayahgroups.com/Media/Branches/16.png",
//             name: "RESTORAN AB EXPRESS PLAZA KLTS - Since 2023",
//             location: "https://share.google/EKPLknFXDEREmq5p2",
//             address: "45-1, Plaza KLTS, Kampung Kuantan, 53000 Kuala Lumpur, Federal Territory of Kuala Lumpur",
//             phoneNo: "+6 01127668379",
//         },
//         {
//             img: "https://albidayahgroups.com/Media/Branches/17.png",
//             name: "RESTORAN AL-BIDAYAH KUANTAN - Since 2024",
//             location: "https://share.google/duN9rVxZA4VkQivLr",
//             address: "B56 Lorong Kg Padang Jaya, 27, Jalan Kuantan Sungai Lembing, Perkampungan Padang Jaya, 25200 Kuantan, Pahang",
//             phoneNo: "+6 095478510",
//         },
//         {
//             img: "",
//             name: "RESTORAN AL-BIDAYAH DESHA MELWATI - Since 2024",
//             location: "https://share.google/dyp563aPWlir4WbA1",
//             address: "23, Jalan 2/4C, Desa Melawati, 53100 Kuala Lumpur, Wilayah Persekutuan Kuala Lumpur",
//             phoneNo: "+6 0341621322",
//         },
//         {
//             img: "",
//             name: "RESTORAN COURTALLAM BORDER POROTTA - Since 2024",
//             location: "https://share.google/Q0EPAZki4OxxECZcy",
//             address: "83 Jalan Medan Bunus, Jalan Masjid India, 50100 Kuala Lumpur",
//             phoneNo: "+6 018916 1096",
//         },
//         {
//             img: "",
//             name: "MADRAS BAKERY BRICKFIELDS - Since 2024",
//             location: "https://share.google/tgHOYZaYKZvJhutDx",
//             address: "R15 / G-12, Sentral Suites Retail, Jalan Tun Sambanthan, Brickfields, 50470 Kuala Lumpur, Wilayah Persekutuan Kuala Lumpur",
//             phoneNo: "+6 0128682786",
//         },
//         {
//             img: "https://albidayahgroups.com/Media/Branches/15.png",
//             name: "RESTORAN JUNIOR KUPANNA BRICKFIELDS - Since 2024",
//             location: "https://share.google/fR8U5x3EfEdXzFcbs",
//             address: "182, Jalan Tun Sambanthan, Brickfields, 50470 Kuala Lumpur, Wilayah Persekutuan Kuala Lumpur",
//             phoneNo: "+6 0185733239",
//         },
//         {
//             img: "https://albidayahgroups.com/Media/Branches/14.png",
//             name: "MADRAS BAKERY LITTLE INDIA - Since 2024",
//             location: "https://share.google/MpXSGpe1bKZVo0xdG",
//             address: "261G, Ground Floor, Jalan Tun Sambanthan, Brickfields, 50470 Kuala Lumpur, Wilayah Persekutuan Kuala Lumpur",
//             phoneNo: "+6 0174716619",
//         },
//   ];

//   return (
//     <div>
//       {/* Hero Section */}
//       <div className="relative w-full h-screen">
//         <div
//           className="absolute inset-0 bg-cover bg-center"
//           style={{
//             backgroundImage: `url('https://albidayahgroups.com/Media/Branches/Branch.jpg')`,
//           }}
//         ></div>
//         <div className="absolute inset-0 bg-black bg-opacity-50 mix-blend-multiply"></div>

//         <div className="relative z-10 flex items-center h-full px-6 md:px-16">
//           <div className="text-white">
//             <FadeInSectionDownToUp>
//               <h1 className="text-6xl max-sm:text-4xl font-bold mb-4 leading-tight">
//                 A Network of{" "}
//                 <span className="text-yellow-500">Trust,</span>
//                 <br />
//                 Serving Communities.
//               </h1>
//               <p className="text-lg md:text-xl max-w-xl">
//                 Welcome to AL-BIDAYAH Branches - where quality meets you,
//                 wherever you are.
//               </p>
//             </FadeInSectionDownToUp>
//           </div>
//         </div>
//       </div>

//       {/* Branches List */}
//       <div className="px-6 md:px-16 py-20 max-sm:py-10 space-y-12">
//         {branches.map((branch, index) => (
//           <FadeInSectionDownToUp key={index}>
//             <div className="flex flex-col md:flex-row items-start md:items-center gap-8 bg-white rounded-2xl shadow-lg p-6">
//               {/* Left: Image + Name + Location */}
//               <div className="w-full md:w-1/3 relative">
//                 {branch.img ? (
//                   <img
//                     src={branch.img}
//                     alt={branch.name}
//                     className="w-full h-52 object-cover rounded-2xl"
//                   />
//                 ) : (
//                   <div className="w-full h-52 bg-gray-200 flex items-center justify-center rounded-2xl text-gray-500">
//                     No Image
//                   </div>
//                 )}

//                 {/* Location Icon */}
//                 <div className="absolute top-3 right-3">
//                   <div className="relative group bg-white rounded-full p-2 shadow-md hover:scale-105 transition-all ease-in-out duration-500">
//                     <a
//                       href={branch.location}
//                       target="_blank"
//                       rel="noopener noreferrer"
//                     >
//                       <FaLocationDot size={20} className="text-[#023E4E]" />
//                     </a>
//                     {/* Tooltip */}
//                     <div className="absolute top-full right-1/2 translate-x-1/2 mt-2 w-max px-3 py-1 text-sm text-white bg-black rounded opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10 whitespace-nowrap">
//                       Click for location
//                     </div>
//                   </div>
//                 </div>

//                 {/* Branch Name */}
//                 <div className="absolute bottom-3 left-3 bg-white bg-opacity-90 text-[#023E4E] text-sm font-semibold px-3 py-1 rounded-full shadow">
//                   {branch.name}
//                 </div>
//               </div>

//               {/* Right: Address + Phone */}
//               <div className="flex-1 space-y-4">
//                 <p className="text-[#023E4E] text-lg md:text-xl font-medium">
//                   {branch.address}
//                 </p>
//                 {branch.phoneNo && (
//                   <p className="text-gray-700">
//                     📞 <a href={`tel:${branch.phoneNo}`}>{branch.phoneNo}</a>
//                   </p>
//                 )}
//               </div>
//             </div>
//           </FadeInSectionDownToUp>
//         ))}
//       </div>
//     </div>
//   );
// }





import React from "react";
import FadeInSectionDownToUp from "../../Components/FadeAnimations/FadeInSectionDownToUp";
import { FaLocationDot } from "react-icons/fa6";

export default function Branches() {

    const branches = [

        {
            img: "https://albidayahgroups.com/Media/Branches/New/01.jpg",
            name: "RESTORAN AL-BIDAYAH SELAYANG - Since 1996 (HQ)",
            location: "https://share.google/dLo5FtCBI541SDEUx",
            address: "24, Jalan 2/12, Dataran Templer, 68100 Batu Caves, Selangor",
            phoneNo: "+6 0367327286",
            bgColour: "bg-[#FFD700]",
        },
        {
            img: "https://albidayahgroups.com/Media/Branches/New/02.jpg",
            name: "RESTORAN AL-BIDAYAH KLANG - Since 2004",
            location: "https://share.google/vhDJ7feWwdCuwbPt5",
            address: "34, Jalan Sri Sarawak 19, Taman Sri Andalas, 41200 Klang, Selangor",
            phoneNo: "+6 0187867701",
            bgColour: "bg-white",
        },
        {
            img: "https://albidayahgroups.com/Media/Branches/New/03.jpg",
            name: "RESTORAN AL-BIDAYAH RAWANG - Since 2008",
            location: "https://share.google/TX0Ep0d723ogQLVJB",
            address: "18, Jalan Desa 1/1, Bandar Country Homes, 48000 Rawang, Selangor",
            phoneNo: "+6 0168060881",
            bgColour: "bg-white",
        },
        {
            img: "https://albidayahgroups.com/Media/Branches/New/04.jpg",
            name: "RESTORAN AL-BIDAYAH SETIAWANGSA - Since 2012",
            location: "https://share.google/dctHcNrAjwGO55yTS",
            address: "No 23, 55A, Jalan Setiawangsa 8, Taman Setiawangsa, 54200 Kuala Lumpur, Wilayah Persekutuan Kuala Lumpur",
            phoneNo: "+6 0342652023",
            bgColour: "bg-white",
        },
        {
            img: "https://albidayahgroups.com/Media/Branches/New/05.jpg",
            name: "RESTORAN AL-BIDAYAH TTDI - Since 2015",
            location: "https://share.google/WyLPBsMJOEvoXISQK",
            address: "1, Lorong Rahim Kajai 13, Taman Tun Dr Ismail, 60000 Kuala Lumpur, Wilayah Persekutuan Kuala Lumpur",
            phoneNo: "+6 0377319167",
            bgColour: "bg-white",
        },
        {
            img: "https://albidayahgroups.com/Media/Branches/New/06.jpg",
            name: "RESTORAN AL-BIDAYAH MASJID INDIA - Since 2015",
            location: "https://share.google/cmBCvcI438IrDCqlh",
            address: "83, Jalan Masjid India, City Centre, 50100 Kuala Lumpur, Wilayah Persekutuan Kuala Lumpur",
            phoneNo: "+6 0104324233",
            bgColour: "bg-white",
        },
        {
            img: "https://albidayahgroups.com/Media/Branches/New/07.jpg",
            name: "RESTORAN AL-BIDAYAH KUALA SELANGOR - Since 2015",
            location: "https://share.google/rnjkY2KHmOmC9aa9b",
            address: "No 50 Jalan Melawati 3/17, Bandar Melawati, 45000 Kuala Selangor, Selangor Darul Eshan",
            phoneNo: "+6 0332813338",
            bgColour: "bg-white",
        },
        {
            img: "https://albidayahgroups.com/Media/Branches/New/08.jpg",
            name: "RESTORAN AL-BIDAYAH CYBERJAYA - Since 2016",
            location: "https://share.google/VtWXp0BTsbXxCWqHd",
            address: "Gem In Mall, Persiaran Sepang, Cyber 11, 63000 Cyberjaya, Selangor",
            phoneNo: "+6 0192226760",
            bgColour: "bg-white",
        },
        {
            img: "https://albidayahgroups.com/Media/Branches/New/09.jpg",
            name: "RESTORAN AL-BIDAYAH SINGAPORE - Since 2017",
            location: "https://share.google/oeSpbEQq1HXFQWgX9",
            address: "364 Geylang Rd, Singapore 389369",
            phoneNo: "+65 67466786",
            bgColour: "bg-white",
        },
        {
            img: "https://albidayahgroups.com/Media/Branches/New/10.jpg",
            name: "RESTORAN AL-BIDAYAH PLAZA KLTS - Since 2018",
            location: "https://share.google/mkLWUhLufuh3Lqrg6",
            address: "No 1 G Block A, Plaza KLTS, Jln Gombak, Kampung Kuantan, 53300 KLTS, Federal Territory of Kuala Lumpur",
            phoneNo: "+6 0340314267",
            bgColour: "bg-white",
        },
        {
            img: "https://albidayahgroups.com/Media/Branches/New/11.jpg",
            name: "RESTORAN AL-BIDAYAH SENTUL POINT - Since 2021",
            location: "https://share.google/wNtuRjBC3uhcPy5A3",
            address: "AG-21, 8, Jln Sentul Pasar, Puncak sentul, 51000 Kuala Lumpur, Wilayah Persekutuan Kuala Lumpur",
            phoneNo: "+6 0340238121",
            bgColour: "bg-white",
        },
        {
            img: "https://albidayahgroups.com/Media/Branches/New/12.jpg",
            name: "RESTORAN AL-BIDAYAH PULAU PINANG - Since 2022",
            location: "https://share.google/HmA41NpcEpBMvOzQ0",
            address: "34g, Lbh Sungai Pinang 1, 11600 George Town, Pulau Pinang",
            phoneNo: "+6 042805239",
            bgColour: "bg-white",
        },
        {
            img: "https://albidayahgroups.com/Media/Branches/New/13.jpg",
            name: "MADRAS BAKERY MASJID INDIA - Since 2023",
            location: "https://share.google/iOv8iaPwCIPc90a34",
            address: "92, Ground Floor, Jalan Medan Bunus, Jalan Masjid India, 50100 Kuala Lumpur, Wilayah Persekutuan Kuala Lumpur",
            phoneNo: "+6 0182808449",
            bgColour: "bg-white",
        },
        {
            img: "https://albidayahgroups.com/Media/Branches/New/14.jpg",
            name: "RESTORAN JUNIOR KUPANNA LEBUH AMPANG - Since 2023",
            location: "https://share.google/p6JB811lO5Z4b6AzR",
            address: "10 & 12 Jalan Gereja, Lebuh Ampang, 50100 Kuala Lumpur, Federal Territory of Kuala Lumpur",
            phoneNo: "+6 0189571098",
            bgColour: "bg-white",
        },
        {
            img: "https://albidayahgroups.com/Media/Branches/New/15.jpg",
            name: "RESTORAN AB EXPRESS PLAZA KLTS - Since 2023",
            location: "https://share.google/EKPLknFXDEREmq5p2",
            address: "45-1, Plaza KLTS, Kampung Kuantan, 53000 Kuala Lumpur, Federal Territory of Kuala Lumpur",
            phoneNo: "+6 01127668379",
            bgColour: "bg-white",
        },
        {
            img: "https://albidayahgroups.com/Media/Branches/New/16.jpg",
            name: "RESTORAN AL-BIDAYAH KUANTAN - Since 2024",
            location: "https://share.google/duN9rVxZA4VkQivLr",
            address: "B56 Lorong Kg Padang Jaya, 27, Jalan Kuantan Sungai Lembing, Perkampungan Padang Jaya, 25200 Kuantan, Pahang",
            phoneNo: "+6 095478510",
            bgColour: "bg-white",
        },
        {
            img: "https://albidayahgroups.com/Media/Branches/New/17.jpg",
            name: "RESTORAN AL-BIDAYAH DESA MELAWATI - Since 2024",
            location: "https://share.google/dyp563aPWlir4WbA1",
            address: "23, Jalan 2/4C, Desa Melawati, 53100 Kuala Lumpur, Wilayah Persekutuan Kuala Lumpur",
            phoneNo: "+6 0341621322",
            bgColour: "bg-white",
        },
        {
            img: "https://albidayahgroups.com/Media/Branches/New/18.jpg",
            name: "RESTORAN COURTALLAM BORDER POROTTA - Since 2024",
            location: "https://share.google/Q0EPAZki4OxxECZcy",
            address: "83 Jalan Medan Bunus, Jalan Masjid India, 50100 Kuala Lumpur",
            phoneNo: "+6 018916 1096",
            bgColour: "bg-white",
        },
        {
            img: "https://albidayahgroups.com/Media/Branches/New/19.jpg",
            name: "MADRAS BAKERY BRICKFIELDS - Since 2024",
            location: "https://share.google/tgHOYZaYKZvJhutDx",
            address: "R15 / G-12, Sentral Suites Retail, Jalan Tun Sambanthan, Brickfields, 50470 Kuala Lumpur, Wilayah Persekutuan Kuala Lumpur",
            phoneNo: "+6 0128682786",
            bgColour: "bg-white",
        },
        {
            img: "https://albidayahgroups.com/Media/Branches/New/20.jpg",
            name: "RESTORAN JUNIOR KUPANNA BRICKFIELDS - Since 2024",
            location: "https://share.google/fR8U5x3EfEdXzFcbs",
            address: "182, Jalan Tun Sambanthan, Brickfields, 50470 Kuala Lumpur, Wilayah Persekutuan Kuala Lumpur",
            phoneNo: "+6 0185733239",
            bgColour: "bg-white",
        },
        {
            img: "https://albidayahgroups.com/Media/Branches/New/21.jpg",
            name: "MADRAS BAKERY LITTLE INDIA - Since 2024",
            location: "https://share.google/MpXSGpe1bKZVo0xdG",
            address: "261G, Ground Floor, Jalan Tun Sambanthan, Brickfields, 50470 Kuala Lumpur, Wilayah Persekutuan Kuala Lumpur",
            phoneNo: "+6 0174716619",
            bgColour: "bg-white",
        },

    ]

    return (
        <div className="pb-20 bg-slate-100">
            {/* Hero Section */}
            <div className="relative w-full h-screen">
                <div
                    className="absolute inset-0 bg-cover bg-center"
                    style={{
                        backgroundImage: `url('https://albidayahgroups.com/Media/Branches/Branch.jpg')`,
                    }}
                ></div>
                <div className="absolute inset-0 bg-black bg-opacity-50 mix-blend-multiply"></div>

                <div className="relative z-10 flex items-center h-full px-6 md:px-16">
                    <div className="text-white">
                        <FadeInSectionDownToUp>
                            <h1 className="text-6xl max-sm:text-4xl font-bold mb-4 leading-tight">
                                A Network of{" "}
                                <span className="text-yellow-500">Trust,</span>
                                <br />
                                Serving Communities.
                            </h1>
                            <p className="text-lg md:text-xl max-w-xl">
                                Welcome to AL-BIDAYAH Branches - where quality meets you,
                                wherever you are.
                            </p>
                        </FadeInSectionDownToUp>
                    </div>
                </div>
            </div>

            {/* Branches List */}
            <div className="px-6 md:px-16 py-20 max-sm:py-10 space-y-12 relative">
                <div
                    className="absolute inset-0 bg-cover bg-center opacity-10"
                    style={{ backgroundImage: `url('https://albidayahgroups.com/Media/Restaurant/pattern%20bg.svg')` }}
                />
                {branches.map((branch, index) => (
                    <FadeInSectionDownToUp key={index}>
                        <div className={`flex flex-col md:flex-row items-start md:items-center gap-8 ${branch.bgColour} rounded-2xl shadow-lg p-6 overflow-hidden relative`}>

                            <div
                                className="absolute inset-0 bg-no-repeat bg-[length:auto_50%] bg-left-bottom scale-x-[-1] pointer-events-none z-0 opacity-40 max-sm:opacity-10"
                                style={{
                                    backgroundImage: `url('https://albidayahgroups.com/Media/Home/Frame%20314041.png')`,
                                    // opacity: "0.4"
                                }}
                            />
                            {/* Left: Image + Name + Location */}
                            <div className="w-1/2 max-sm:w-full relative">
                                {branch.img ? (
                                    <img
                                        src={branch.img}
                                        alt={branch.name}
                                        className="w-full object-cover rounded-2xl"
                                    />
                                ) : (
                                    <div className="w-full bg-gray-200 flex items-center justify-center rounded-2xl text-gray-500">
                                        No Image
                                    </div>
                                )}

                                {/* Location Icon */}
                                <div className="absolute top-3 right-3">
                                    <div className="relative group bg-white rounded-full p-2 shadow-md hover:scale-105 transition-all ease-in-out duration-500">
                                        <a
                                            href={branch.location}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <FaLocationDot size={20} className="text-[#023E4E]" />
                                        </a>
                                        {/* Tooltip */}
                                        <div className="absolute top-full right-1/2 translate-x-1/2 mt-2 w-max px-3 py-1 text-sm text-white bg-black rounded opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10 whitespace-nowrap">
                                            Click for location
                                        </div>
                                    </div>
                                </div>

                                {/* Branch Name Overlay on Image */}
                                {/* <div className="absolute bottom-3 left-3 bg-white bg-opacity-90 text-[#023E4E] text-sm font-semibold px-3 py-1 rounded-full shadow">
                                    {branch.name}
                                </div> */}
                            </div>

                            {/* Right: Branch Details */}
                            <div className="flex-1 space-y-5">
                                {/* Branch Name also on right side */}
                                <h2 className="text-2xl max-sm:text-xl font-bold text-[#023E4E]">
                                    {branch.name}
                                </h2>

                                <div>
                                    <a href={branch.location} target="_blank" rel="noopener noreferrer" className="text-[#023E4E] text-lg md:text-xl font-medium">
                                        {branch.address}
                                    </a>
                                </div>

                                {/* Show phone only if available */}
                                {branch.phoneNo && (
                                    <p className="text-gray-700 text-xl">
                                        📞 <a href={`tel:${branch.phoneNo}`}>{branch.phoneNo}</a>
                                    </p>
                                )}
                            </div>
                        </div>
                    </FadeInSectionDownToUp>
                ))}
            </div>
        </div>
    );
}
